import * as Sentry from '@sentry/angular';
import Package from '../../../package.json';
import { ConfigService, AppConfig } from '../services/config/config.service';
export function initializeSentry(configService: ConfigService) {
  return (): Promise<void> =>
    configService
      .loadAppConfig()
      .then((data: AppConfig) => {
        if (data?.sentry?.enabled === true) {
          const tracePropagationTargets = typeof data.sentry.tracePropagationTargets === 'string'
            ? JSON.parse(data.sentry.tracePropagationTargets.replaceAll("'", '"'))
            : data.sentry.tracePropagationTargets;

          Sentry.init({
            dsn: data.sentry.dsn,
            environment: data.sentry.environment,
            release: `${Package.name}@${Package.version}`,
            integrations: [
              Sentry.browserTracingIntegration(),
              Sentry.replayIntegration(),
              Sentry.breadcrumbsIntegration({
                console: data.sentry.enabled,
              })
            ],
            // Performance Monitoring
            tracesSampleRate: data.sentry.tracesSampleRate,
            // Session Replay
            replaysSessionSampleRate: data.sentry.replaysSessionSampleRate,
            replaysOnErrorSampleRate: data.sentry.replaysOnErrorSampleRate,
            tracePropagationTargets: tracePropagationTargets
        });
        }
      })
      .catch((error) => console.error('Error in Sentry comp', error));
}
